module.exports = __webpack_public_path__ + "img/p17.5675ceb6.jpg";